__turbopack_context__.v({
  "root": "uxIU0W_root",
});
